import React from 'react';
import { Link } from 'react-router-dom';

import ProspectListManagement from '../components/prospectLists/ProspectListManagement';

const ProspectListsPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="-mt-4 mb-6">
        <Link
          to="/nouveaux-adherents"
          className="text-blue-600 hover:text-blue-800 flex items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Retour à la prospection
        </Link>
      </div>

      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Listes de prospects</h1>
        <p className="mt-2 text-sm text-gray-600">
          Importez vos prospects existants depuis un logiciel tiers afin de les exclure automatiquement de
          vos recherches de prospection.
        </p>
      </div>

      <ProspectListManagement />
    </div>
  );
};

export default ProspectListsPage;

